import FoodIcon3 from '@assets/images/food3.png';
import FoodIcon4 from '@assets/images/food4.png';
import BillIcon from '@assets/images/bill.png';
import NonBillIcon from '@assets/images/non-bill.png';
import RoomIcon from '@assets/images/room.png';
import NonRoomIcon from '@assets/images/non-room.png';
import UPIIcon from '@assets/images/upi-icon.png';

// Search here for icons https://fonts.google.com/icons?icon.query=sweet
type tplotOptions = {
    [key: string]: string
}

export const IconMap: tplotOptions = {
    'drinks': 'local_bar',
    'fast-food': 'fastfood',
    'sweets': 'cake',
    // 'egg-special': 'egg',
}

export const StatusMap = [
    {label: 'Received', value: 'received'},
    {label: 'Pending', value: 'pending'},
    {label: 'Packing', value: 'packing'},
    {label: 'On the way', value: 'on-the-way'},
    {label: 'Delivered', value: 'delivered'},
];

export const PaymentTypes = [
    {label: 'cash', value: 'cash'},
    {label: 'online', value: 'online'},
    {label: 'cheque', value: 'cheque'},
    {label: 'pending', value: 'pending'},
];

export const FILTERS = [
    { label: 'Last 2-Days', value: 2 },
    { label: 'Last 5-Days', value: 5 },
    { label: 'Last 30-Days', value: 30 },
    { label: 'Custom', value: 'custom' },
];

export const FilterRoomDate = [
    { label: 'Last 5-Days', value: 5 },
    { label: 'Last 10-Days', value: 10 },
    { label: 'Last 20-Days', value: 20 },
    { label: 'Last 30-Days', value: 30 },
    { label: 'Custom', value: 'custom' },
];

export const FilterPaymentType = [
    {label: 'All', value: 'all'},
    {label: 'Cash', value: 'cash'},
    {label: 'Online', value: 'online'},
    {label: 'Cheque', value: 'cheque'},
    {label: 'Pending', value: 'pending'},
];

export const ImagesGS = {
    itemPlaceholder: FoodIcon4,
    itemLightPlaceholder: FoodIcon3,
    BillIcon,
    NonBillIcon,
    RoomIcon,
    NonRoomIcon,
    UPIIcon,
};
